
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(4(632|74|98)|25(30|42)|5(064|459|622)|6(319|671|705|844)|1(107|493|545|796|834|889|980)|8(080|322|626|750)|7(046|224|345|875)|3(2(06|45|91|95)|104|730)|9(7(22|26|30)|107|396|415))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
